const Application = ''
export const route = {
    loan: {
        key:`${Application}/loan`,
        index: `${Application}/loan/index`,
        create: `${Application}/loan/create`,
        single: `${Application}/loan/single`,
    },
    search:{
        key:`${Application}/search`,
        index: `${Application}/search/index`,
        device:`${Application}/search/device`,
        edit_device:`${Application}/search/device_edit/`,
        single: `${Application}/search/single`,
        export: `${Application}/search/export`,
        clear_activation: `${Application}/search/clear_activation`,
    },
    operation:{
        key:`${Application}/operation`,
        index: `${Application}/operation/logs`,
       // single: `${Application}/loan/single`,
    },
    group:{
        key:`${Application}/group`,
        index: `${Application}/group/index`,
        edit: `${Application}/group/edit/`,
        create:`${Application}/group/create`,
        custom:`${Application}/group/custom/`,
        role:`${Application}/group/role/`,
    },
    customs:{
        key:`${Application}/custom`,
        index: `${Application}/custom/index`,
        edit: `${Application}/custom/edit/`,
        create:`${Application}/custom/create`,
        app:`${Application}/custom/app/`
    },
    user: {
        key:`${Application}/user`,
        index: `${Application}/user/index`,
        edit: `${Application}/user/reset/`,
        create:`${Application}/user/create`,
        bind_group:`${Application}/user/group/`,
    },
    device_finance:{
        key:`${Application}/device_finance`,
        index: `${Application}/device_finance/index`,
    },

    finance:{
        key:`${Application}/device`,
        index: `${Application}/device/finance`,
    },
    role:{
        key:`${Application}/role`,
        index: `${Application}/role/index`,
        edit:`${Application}/role/edit/`,
        create:`${Application}/role/create`,
        perm:`${Application}/role/perm/`,
    },
    perm:{
        key:`${Application}/perm`,
        index: `${Application}/perm/index`,
    },
    dashboard:{
        key:`${Application}/dashboard`,
        index: `${Application}/dashboard/index`,
        activation: `${Application}/dashboard/activation`,
        device_activity: `${Application}/dashboard/device/activity`,
        battery_insight: `${Application}/dashboard/battery/insight`,
       // dashboard2: `${Application}/dashboard/view`,
        nfc_insight: `${Application}/dashboard/nfc/insight`,
    },
    manager:{
        key:`${Application}/manage`,
        clear_activation:`${Application}/manage/clear/avctivation`,
        export:`${Application}/manage/export`,
    },
    default: {
        page404: '/404',
        login: '/login',
    }
}